import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { RESPONSE_TYPES } from '../settings/general/PublicActionsResponses';
import { SubTypeStats } from '../../hooks/usage/useUsageTracker';
import { SUGGESTION_SUBTYPES } from '../../constants/processing';

interface SubTypeStatsListProps {
  subTypeStats: SubTypeStats[];
  isLoading: boolean;
}

const SubTypeStatsList: React.FC<SubTypeStatsListProps> = ({ subTypeStats, isLoading }) => {
  const getSubTypeLabel = (subType: string) => {
    const responseType = SUGGESTION_SUBTYPES[subType as keyof typeof SUGGESTION_SUBTYPES];
    return {
      label: responseType?.label || subType,
      description: responseType?.description || '',
      category: responseType?.category || ''
    }
  };

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', mt: 5 }}>
      <CircularProgress />
    </Box>
  }

  if (subTypeStats.length === 0) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', mt: 5 }}>
      <Typography variant="body1">No data found</Typography>
    </Box>
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, overflowX: 'auto', pb: 2, mt: 5 }}>
      {subTypeStats.map((stat) => (
        <Paper 
          key={stat.suggestion_subtype} 
          sx={{ p: 2, minWidth: '300px', bgcolor: '#f5f5f5' }}
        >
          <Typography variant="h6">
            {getSubTypeLabel(stat.suggestion_subtype).label}
          </Typography>
          <Typography variant="body2">
            {getSubTypeLabel(stat.suggestion_subtype).description}
          </Typography>
          <Box sx={{ display: 'flex', gap: 4, mt: 1 }}>
            <Typography>
              Approved: {stat.approved_count}
            </Typography>
            <Typography>
              Rejected: {stat.rejected_count}
            </Typography>
            <Typography>
              Ignored: {stat.ignored_count}
            </Typography>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default SubTypeStatsList;
